// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://api-dev.keystodriving.com",
  // apiUrl: "http://localhost:3000/local",
  s3BucketUrl: "https://s3.amazonaws.com/ktd-dev-website/",
  cognito: {
    region: "us-east-1",    
    userPoolId: "us-east-1_JRGXZLBzL",
    userPoolClientId: "5ku9qtu29a5e3j5afidif72pic",
    authenticationFlowType: "USER_PASSWORD_AUTH"    
  },
  // apiUrl: "https://9snk6xuync.execute-api.us-east-1.amazonaws.com/prod",
  // s3BucketUrl: "https://s3.amazonaws.com/www.keystodriving.com/assets",
  // cognito: {
  //   region: "us-east-1",
  //   userPoolId: "us-east-1_YwvBOeBm5",
  //   userPoolClientId: "15d18654o93n0nsltklstimep9",
  //   authenticationFlowType: "USER_PASSWORD_AUTH"
  // },
  debugMode: true,
  stripeKey: "pk_test_51MP9U3LFCE48FLZzptSet4ysUqoy4y1kBqskU5PoeqoVNAw1gq3Vij7XC1OHIp3hPW0vI2HSRbjoBk3cwTZes2tC00sewLlpoU",
  google: {
    clientId: "582658936584-t0nesfa3lllb6kptruct23ke65dlel5h.apps.googleusercontent.com"
  },
  /** GA4 Measurement ID - uses dev property when set */
  googleAnalyticsId: "G-P1XH1E9TET",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
